
import { Component } from 'preact';
export default class MobileNav extends Component {


		arrowClick = (index) => {
				index = index ? index : 0
				let selectedItemId = this.props.compareProducts[index] && this.props.compareProducts[index].itemId

				this.props.passedSetState('selectedItemId', selectedItemId)
		}


		render(){

			let {selectedItemId, compareProducts} = this.props
			let selectedIndex = 0
			let numberOfItems = compareProducts.length -1
			let dotsHTML = []


			compareProducts.forEach( (current, index) => {
					if (selectedItemId === current.itemId){
						selectedIndex = index
						dotsHTML.push( <div style={{ padding: '5px'}}>
															<div style={{backgroundColor: '#000', height: '10px', width: '10px', borderRadius: '50%', padding: '5px'}} />
														</div>
													)
					} else {
						dotsHTML.push( <div style={{ padding: '5px'}}>
															<div style={{backgroundColor: '#000', height: '10px', width: '10px', borderRadius: '50%', opacity: 0.3, padding: '5px'}} />
														</div>
													)					}
			})

			let forwardIndex = selectedIndex < numberOfItems ? selectedIndex + 1 : null
			let backwardIndex = selectedIndex > 0 ? selectedIndex - 1 : null

			let forwardOpacity
			let backwardOpacity
			let forwardCursor
			let backwardCursor
			let forwardOnClick
			let backwardOnClick

			//if you can go forward
			if (forwardIndex > 0){
				forwardOpacity = 1
				forwardCursor = 'pointer'
				forwardOnClick = () => this.arrowClick(forwardIndex)
			} else {
				forwardOpacity = 0.3
				forwardCursor = 'default'
				forwardOnClick = ()=>  null
			}

			//if you can go backward
			if (backwardIndex === null){
				backwardOpacity = 0.3
				backwardCursor = 'default'
				backwardOnClick = ()=>  null
			} else {
				backwardOpacity = 1
				backwardCursor = 'pointer'
				backwardOnClick = () => this.arrowClick(backwardIndex)
			}

			return (
				<div className='row col-xs-12' style={{paddingBottom: '10px'}}>

						<button className='col-xs-4 mobileNav-button' style={{display: 'flex', justifyContent: 'center'}} onClick={backwardOnClick} >
								<img src='https://firebasestorage.googleapis.com/v0/b/columbus-c4de8.appspot.com/o/util%2Fbackward.png?alt=media&token=dd0b6a8a-d84d-46d4-9f44-473a2a32af81' style={{height: '30px', width: '30px', opacity: backwardOpacity, cursor: backwardCursor}}   />
						</button>

						<div className='col-xs-4' style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
							{dotsHTML}
						</div>

						<button className='col-xs-4 mobileNav-button' style={{display: 'flex', justifyContent: 'center'}}  onClick={forwardOnClick}>
								<img src='https://firebasestorage.googleapis.com/v0/b/columbus-c4de8.appspot.com/o/util%2Fforward.png?alt=media&token=c312b9ef-b932-466c-8bca-51037d6b5010' style={{height: '30px', width: '30px', opacity: forwardOpacity, cursor: forwardCursor}}   />
						</button>

				</div>
			);
		}

}



// WEBPACK FOOTER //
// ./components/contentTypes/compareTable/mobileNav.js